/**
*
* CapVirtualList
*
*/

//Please refer the below linked react-virtuoso documentation for more details and complete list of props
//https://virtuoso.dev/

import React from 'react';
import { Virtuoso } from 'react-virtuoso';

export function CapVirtualList(props) {
  return (
    <Virtuoso {...props} />
  );
}

export default CapVirtualList;